import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import './UserCreate.css';

const UnitEdit = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { unit, company } = location.state || {};

    const [unitName, setUnitName] = useState(unit?.name || '');
    const [unitNickname, setUnitNickname] = useState(unit?.nickname || '');
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (!unitName.trim()) {
            setMessage({ type: 'error', text: 'Preencha o nome da unidade.' });
            return;
        }

        if (!unit?.id) {
            setMessage({ type: 'error', text: 'Unidade não identificada. Volte e tente novamente.' });
            return;
        }

        try {
            setSubmitting(true);
            const result = await apiService.updateUnit({
                unit_id: unit.id,
                name: unitName.trim(),
                nickname: unitNickname.trim() || null,
            });

            if (result.success) {
                setMessage({ type: 'success', text: `Unidade "${unitName.trim()}" atualizada com sucesso!` });
            } else {
                setMessage({ type: 'error', text: result.message || 'Erro ao atualizar unidade.' });
            }
        } catch (err) {
            setMessage({ type: 'error', text: 'Erro ao atualizar unidade. Tente novamente.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="user-create">
            <div className="user-create-header">
                <button className="btn-back" onClick={() => navigate('/users')}>
                    &#8592; Voltar
                </button>
                <h1>Editar Unidade</h1>
            </div>

            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="user-create-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="company">Empresa</label>
                        <input
                            id="company"
                            type="text"
                            value={company?.name || ''}
                            disabled
                            className="form-input"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="unitName">Nome da Unidade</label>
                        <input
                            id="unitName"
                            type="text"
                            value={unitName}
                            onChange={(e) => setUnitName(e.target.value)}
                            className="form-input"
                            placeholder="ex: Brasília"
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="unitNickname">Apelido (opcional)</label>
                        <input
                            id="unitNickname"
                            type="text"
                            value={unitNickname}
                            onChange={(e) => setUnitNickname(e.target.value)}
                            className="form-input"
                            placeholder="ex: BSB"
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={() => navigate('/users')}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={submitting}
                    >
                        {submitting ? 'Salvando...' : 'Salvar Alterações'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UnitEdit;
